import ViewBase from "../../../../framework/core/mvvm/view_base";
import { K9SeatCfg } from "./component/k9_state_config";
import K9Help from "./component/k9_help";
import LanguageManager from "../../../../manager/language_manager";
import K9SidePotEffect from "./component/k9_sidePot_effect";
import GameUtil from "../../../../utility/game_util";
import { K9 } from "./k9_data";
import ModelData from "../../../public/model_data";
import Utility from "../../../../utility/utility";
import AppData from "../../../public/const/app_data";
import TableBaseView from "../../../table/module/table_base/table_base_view";

const {ccclass, property} = cc._decorator;

@ccclass
export default class K9TableView extends TableBaseView {
    @property(cc.Node)
    seatPrefab:cc.Node = null;

    @property(cc.Node)
    seatRoot:cc.Node = null;

    seatState:K9SeatCfg[] = [];

    @property(cc.Node)
    seatTarget:cc.Node = null;

    @property(cc.Label)
    roundNumb:cc.Label = null;

    @property(cc.Node)
    operatorNode:cc.Node = null;

    @property([cc.Node])
    bankers:cc.Node[] = [];

    @property(cc.Node)
    timer:cc.Node = null;

    @property(cc.Node)
    countDown:cc.Node = null;

    @property(cc.Node)
    cardPos:cc.Node = null;

    @property(cc.Node)
    btnPrefab:cc.Node = null;

    @property(cc.Node)
    noRound:cc.Node = null;
    
    @property(K9SidePotEffect)
    sidePool:K9SidePotEffect = null;

    @property(cc.Node)
    bankerNode:cc.Node = null;

    @property(cc.Node)
    potNode:cc.Node = null;

    @property(cc.Node)
    bankNodePos:cc.Node = null;

    @property([cc.Node])
    operatorBtn:cc.Node[] = [];

    @property(cc.Node)
    test:cc.Node = null;

    // @property(cc.Node)
    // rankAnim:cc.Node = null;
    
    onLoad(){
        for (let banker of this.bankers) {
            banker.active = false;
        }
        this.updateOperatorState(2,null)
        this.bankerNode.active = false;
        this.test.active = AppData.testMode;
        this.isShowUpBank(false);
    }

    isShowUpBank(isShow:boolean){
        //this.rankAnim.active = isShow;
    }

    getSeatCfg(viewid:number):K9SeatCfg{
        return this.seatState[viewid];
    }

    isShowBanker(isShow:boolean){
        this.bankerNode.active = isShow;
    }

    setSeatNumb(){
        this.seatState.length = 0;
        if (this.seatTarget) {
            for (let seatSetting of this.seatTarget.children) {
                let info = seatSetting.getComponent(K9SeatCfg);
                this.seatState.push(info);
            }
        }
    }

    roundUI(content:string){
        this.roundNumb.string = content;
    }

    updateBaner(isBanker:boolean){
        this.bankers[0].active = !isBanker;
        this.bankers[1].active = isBanker;
    }

    isShowTimer(isShow:boolean){
        this.countDown.active = isShow;
    }

    protected showTimer(time:number){
        let countNode = this.countDown.getChildByName('numb');
        let des = LanguageManager.t('dz_startnext').format(time);
        K9Help.setNodeString(countNode,des);
    }

    //添加座椅
    addSeat(index:number):cc.Node{
        let target = this.seatState[index];
        let seatNode:cc.Node = null;
        if (target) {
            //seatNode = K9Help.AddChild(this.noPlayerSeat,target.node)
            //seatNode.name = index.toString();
        }
        return seatNode;
    }

    stopUserAction(tag:number){
        this.timer.stopActionByTag(tag);
    }

    updateSidePot(numb:number){
        this.sidePool.updateSidePot([{betCoinSum:numb}]);
    }

    //0-要牌  1-下注 2-无状态
    updateOperatorState(state:number,data:K9.SeatData){
        this.noRound.active = state == 0;
        this.operatorNode.active = state == 1;
        if (state == 1) {//更新下注额
            let rule = ModelData.instance.roomInfo.PlayRuleData;
            for (let i = 0; i < this.operatorNode.childrenCount; i++) {
                let ele = this.operatorNode.children[i];
                if (ele) {
                    let numb = Number(ele.name);
                    let isGray = data.coin_balance < (numb * rule.game_BetSingle ) * 5;
                    this.isGrayBtn(isGray,ele)
                }
            }
        }else if (state == 0) {//要牌
            let isGray = data.card_point < 3 && data.win_rate == 1
            this.isGrayBtn(isGray,this.operatorBtn[1]);
        }
    }

    isGrayBtn(isGray:boolean,node:cc.Node){
        Utility.setNodeGray(node,isGray);
        Utility.setBtnGray(node.getComponent(cc.Button),isGray);
    }

    initOperatorBtn(betArr:number[],betSingle:number){
        if (!betArr) {
            return;
        }
        let temp = betArr.concat([]);
        temp.sort((a:number,b:number)=>{
            return b - a;
        });
        this.operatorNode.removeAllChildren();
        for (let index = 0; index < temp.length; index++) {
            let numb = temp[index];
            let node = K9Help.AddChild(this.btnPrefab,this.operatorNode);
            node.name = numb.toString();
            let numbNumb = node.getChildByName('numb');
            let fnumb = GameUtil.currencyFormatting(numb*betSingle,2,true);
            K9Help.setNodeString(numbNumb,fnumb.toString());
        }
    }

    updateTimer(time:number){
        this.stopUserAction(K9.ActionTag.time);
        this.isShowTimer(time>0);
        if (time<=0) {
            return;
        }
        let count = time;
        this.showTimer(time);
        let action = K9Help.scheduleTimes(this.timer,()=>{
            time--;
            this.showTimer(time);
            if (time<=0) {
                this.isShowTimer(false);
                this.stopUserAction(K9.ActionTag.time);
            }
        },1,count)
        action.setTag(K9.ActionTag.time);
    }

    restStart(){
        this.sidePool.reset();
    }

    restartNextRound(){
        this.sidePool.reset()
    }

}
